import React from "react"

import { motion } from "framer-motion"

import { ThemeProvider } from "styled-components"
import { GlobalStyles, lightTheme, darkTheme } from "../constants/themes"
import useWindowSize from "../constants/useWindowSize"
import useLocalStorage from "../constants/useLocalStorage"

import { Navbar, Sidebar, Footer } from "./"

const Layout = ({ children }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const [isDarkTheme, setDarkTheme, componentMounted] = useLocalStorage("Theme")
  const { width } = useWindowSize()

  const toggleSidebar = () => {
    setIsOpen(!isOpen)
  }

  const toggleTheme = () => {
    setDarkTheme()
  }
  React.useEffect(() => {
    async function loadCodeHighlight() {
      try {
        const deckdeckgoHighlightCodeLoader = require("@deckdeckgo/highlight-code/dist/loader")
        await deckdeckgoHighlightCodeLoader.defineCustomElements(window)
      } catch (err) {
        console.error(err)
      }
    }
    loadCodeHighlight()
  }, [])

  const themeMode = !isDarkTheme ? lightTheme : darkTheme

  if (!componentMounted) {
    return <div />
  }

  return (
    <ThemeProvider theme={themeMode}>
      <GlobalStyles />
      <Navbar
        toggleSidebar={toggleSidebar}
        toggleTheme={toggleTheme}
        isDarkTheme={isDarkTheme}
      />
      {width < 768 && (
        <Sidebar
          isOpen={isOpen}
          toggleSidebar={toggleSidebar}
          setIsOpen={setIsOpen}
        />
      )}
      <motion.main
        initial={{ opacity: 0, x: -200 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: 200 }}
        transition={{
          type: "spring",
          mass: 0.35,
          stiffness: 75,
          duration: 0.3,
        }}
      >
        {children}
      </motion.main>
      <Footer />
    </ThemeProvider>
  )
}

export default Layout
